import { EdgeDocumentsApi } from '@trialcard/apigateway.client';
import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { Mutation, Action } from 'vuex-module-decorators';
import { Resolve } from 'vue-di';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { Settings } from '~/services/settings';
interface IUploadValidation {
    isInvalidType: boolean | null;
    isInvalidSize: boolean | null;
}

@InjectModule({ stateFactory: true }, module)
export default class DocumentUploadModule extends InjectVuexModule {
    @Resolve
    public settings!: Settings;

    @Resolve
    documentApi!: EdgeDocumentsApi;

    public files: VUFile[] = [];
    public validFileTypes = ['application/pdf', 'image/jpg', 'image/jpeg', 'image/png'];
    public maxFileSize = 10000000;
    public pendingUploadSize = 0;
    public totalUploadSize = 0;
    // validation state of incoming upload
    public uploadValidation: IUploadValidation = {
        isInvalidSize: null,
        isInvalidType: null,
    };
    // validation error messages
    public isInvalidSizeError = false;
    public isInvalidTypeError = false;

    @Mutation
    public validateUpload(data: VUFile) {
        const isInvalidSize = data.file.size + this.pendingUploadSize + this.totalUploadSize > this.maxFileSize;
        const isInvalidType = !this.validFileTypes.includes(data.file.type);
        if (!isInvalidSize) {
            this.pendingUploadSize += data.file.size;
        }
        this.uploadValidation = {
            isInvalidSize,
            isInvalidType,
        };
    }

    @Mutation
    setIsInvalidSizeError(value: boolean) {
        this.isInvalidSizeError = value;
    }

    @Mutation
    setIsInvalidTypeError(value: boolean) {
        this.isInvalidTypeError = value;
    }

    @Mutation
    public addFile(data: VUFile) {
        this.files.push(data);
        this.totalUploadSize += data.file.size;
    }

    @Mutation
    public removeFile(data: VUFile) {
        const index = this.files.findIndex(file => file.id === data.id);
        this.files.splice(index, 1);
        this.totalUploadSize -= data.file.size;
    }

    @Mutation
    public clearPendingUploads() {
        this.pendingUploadSize = 0;
    }

    @Mutation
    public resetUploadValidation() {
        this.uploadValidation = {
            isInvalidSize: null,
            isInvalidType: null,
        };
    }

    @Mutation
    public clearStore() {
        this.files = [];
        this.uploadValidation = {
            isInvalidSize: null,
            isInvalidType: null,
        };
        this.isInvalidSizeError = false;
        this.isInvalidTypeError = false;
        this.pendingUploadSize = 0;
        this.totalUploadSize = 0;
    }

    @Action({})
    async clsuploadDocument(request: { file: File; documentTypeId: string | null }) {
        // try {
        //     const attachment = {
        //         value: Buffer.from(await request.file.arrayBuffer())
        //     }
        //     const documentTypeId = request.documentTypeId ? +request.documentTypeId : 10001;
        //     const { data } = await this.documentApi.documentUpload(documentTypeId, attachment , this.settings.clsProgramId!,  'CLS', 'GSKO')
        //     return data.data && data.success;
        // } catch {
        //     return false;
        // }
         try {
            const documentTypeId = request.documentTypeId ? +request.documentTypeId : 10001;

            let fileName = request.file.name;
            if (!fileName.toLowerCase().endsWith('.pdf')) {
                fileName = fileName.replace(/\.[^/.]+$/, '') + '.pdf';
            }

            const fileToUpload = fileName !== request.file.name
                ? new File([request.file], fileName, { type: 'application/pdf' })
                : request.file;

            const blob = new Blob([await fileToUpload.arrayBuffer()], { type: 'application/pdf' });

            const attachment = {
                value: blob
            } as unknown as { value: Buffer };

            const { data } = await this.documentApi.documentUpload(
                documentTypeId,
                attachment,
                this.settings.clsProgramId!,
                fileName,
                'CLS',
                'GSKO'
            );
            return data && data.success;
        } catch (error) {
            // console.error('Document upload error:', error);
            return false;
        }
    }

    @Action({})
    async qpUploadDocument(request: { file: File; documentTypeId: string | null }) {
        //  try {
        //     const attachment = {
        //         value: Buffer.from(await request.file.arrayBuffer())
        //     }
        //     const documentTypeId = request.documentTypeId ? +request.documentTypeId : 10001;
        //     const { data } = await this.documentApi.documentUpload(documentTypeId, attachment , this.settings.programId!)
        //     return data.data && data.success;
        // } catch {
        //     return false;
        // }
        try {
            const documentTypeId = request.documentTypeId ? +request.documentTypeId : 10001;

            let fileName = request.file.name;
            if (!fileName.toLowerCase().endsWith('.pdf')) {
                fileName = fileName.replace(/\.[^/.]+$/, '') + '.pdf';
            }

            const fileToUpload = fileName !== request.file.name
                ? new File([request.file], fileName, { type: 'application/pdf' })
                : request.file;

            const blob = new Blob([await fileToUpload.arrayBuffer()], { type: 'application/pdf' });

            const attachment = {
                value: blob
            } as unknown as { value: Buffer };

            const { data } = await this.documentApi.documentUpload(
                documentTypeId,
                attachment,
                this.settings.programId!,
                fileName
            );
            return data && data.success;
        } catch (error) {
            // console.error('Document upload error:', error);
            return false;
        }
    }
}
